<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="400">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col
        ><currency-list-select
          v-model="currencyCode"
          :outlined="outlinedInputs"
        ></currency-list-select
      ></v-col>
      <v-col>
        <v-text-field
          v-model.number="rate"
          label="Rate"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <date-range-picker
          :gt-date-from-string="dateFrom"
          :gt-date-to-string="dateTo"
          :outlined="outlinedInputs"
          @onRangeSelected="onDatesChange"
        ></date-range-picker>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code
        >{{ isValid }} {{ currencyCode }}{{ currencyCode }} {{ rate != 0 }}
        {{ value }}
      </code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import DateRangePicker from "../../shared/DatesRangePicker";

import CurrencyListSelect from "../../shared/CurrencyListSelect.vue";
export default {
  name: "exchange-rate-edit-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    DateRangePicker,
    CurrencyListSelect,
  },

  data() {
    return {
      debug: false,
      dateFrom: this.value ? this.value.dateFrom : "",
      dateTo: this.value ? this.value.dateTo : "",
      rate: this.value ? this.value.rate : 0,
      currencyCode: this.value ? this.value.currencyCode : "",
    };
  },

  computed: {
    title() {
      return this.value.id != null
        ? this.value.currencyCode
        : "New Exchange Rate";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.dateFrom != "" &&
        this.dateTo != "" &&
        this.rate != 0 &&
        this.currencyCode != ""
      );
    },
  },

  watch: {
    value(newVal) {
      this.currencyCode = newVal.currencyCode ? newVal.currencyCode : "";
      this.dateFrom = newVal.dateFrom ? newVal.dateFrom : "";
      this.dateTo = newVal.dateTo ? newVal.dateTo : "";
      this.rate = newVal.rate ? newVal.rate : 0;
    },
  },

  methods: {
    onDatesChange(range) {
      this.dateFrom = range.dateFrom;
      this.dateTo = range.dateTo;
    },
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        currencyCode: this.currencyCode,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        rate: Number(this.rate),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/ExchangeRateEditDialog.vue